<div class="admin-documents">
    <page-header
        [titleText]="this.getBusinessName()"
        [shortBottomPadding]="true"
        backButtonText="Back To Client Management"
        (handleBackButtonClick)="navigateBackToClientManagement()"
    >
    </page-header>
    <div class="container-fluid page-container">
        <dr-tab
            [dynamicRouterLink]="dynamicRouterLink"
            [formGroup]="formGroup"
            [viewedBy]="'admin'"
            [schemaType]="'DocumentCenter'"
            [adminMode]="true"
            [companyKey]="companyKey"
        ></dr-tab>
    </div>
</div>
